import { Box, Typography, useMediaQuery, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cs from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileFilterLink from '../../../components/MobileFilterLink';
import SearchInputField from '../../../components/fields/SearchInputField';
import useCommonStyles from '../../../useCommonStyles';

export type SearchHeaderProps = {
    search: string;
    title?: string;
    searchOnChange: (searchValue: string) => void;
    setShowFilterDialog: (value: boolean) => void;
    setShowFilterMenu: (value: boolean) => void;
    showFilter?: boolean;
};

const SearchHeader = ({
    search,
    title,
    searchOnChange,
    setShowFilterDialog,
    setShowFilterMenu,
    showFilter,
}: SearchHeaderProps) => {
    const { t } = useTranslation(['saleTransactionsPage', 'common']);
    const commonStyles = useCommonStyles();
    const theme = useTheme();

    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    if (isSmall) {
        return (
            <Box>
                {title && (
                    <Box mb={3}>
                        <Typography className={commonStyles.title}>{title}</Typography>
                    </Box>
                )}
                <Box width="100%">
                    <SearchInputField onChange={searchOnChange} placeholder={t('common:search')} value={search} />
                </Box>

                {showFilter && (
                    <Box mt={3}>
                        <Box alignItems="center" display="flex">
                            <Box mr="auto">
                                <MobileFilterLink setShowFilterDialog={setShowFilterDialog} />
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <Box alignItems="center" className={commonStyles.header} display="flex">
            {title && (
                <Box>
                    <Typography className={commonStyles.title}>{title}</Typography>
                </Box>
            )}
            <Box ml="auto">
                <SearchInputField onChange={searchOnChange} placeholder={t('common:search')} value={search} />
            </Box>
            {showFilter && (
                <Box className={cs(commonStyles.buttonGroup, commonStyles.buttonGroupHeader)}>
                    <Button color="secondary" onClick={() => setShowFilterMenu(true)} size="large" variant="contained">
                        {t('saleTransactionsPage:filterBy')} <ExpandMoreIcon fontSize="small" />
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default SearchHeader;
